// key: route that requires a permission
// value: permission required in order to use the route

export const authorizedRouteMap = {
  '/benefits': 'selfService:write:benefits',
  '/benefits/add': 'selfService:write:benefits',
  '/benefits/:id/v/:versionId': 'selfService:write:benefits',
  '/selfService': 'selfService:read:auths',
  '/selfService/:authId': 'selfService:read:auths',
};